var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as firebaseApp from "firebase/app";
import * as firebaseFunctions from "firebase/functions";
const app = {
    initializeApp: () => firebaseApp.initializeApp({
        apiKey: "AIzaSyCyGzqeB5UYGmU_qsiMRAcZa88kwEezCD0",
        authDomain: "strongest-mashimashi.firebaseapp.com",
        projectId: "strongest-mashimashi",
        storageBucket: "strongest-mashimashi.appspot.com",
        messagingSenderId: "404083950358",
        appId: "1:404083950358:web:861de5f1597aef9e604637",
        measurementId: "G-76Y4K0PXX8",
    }),
};
export const functions = {
    generate: () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield firebaseFunctions.httpsCallable(firebaseFunctions.getFunctions(app.initializeApp(), "asia-northeast1"), "generate")({});
        return yield response.data.phrase;
    }),
};



//////////////////
// WEBPACK FOOTER
// ./src/firebase.ts
// module id = 23
// module chunks = 0